(function () {
  // Prefers-reduced-motion guard
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Sticky nav scroll state
  //    Toggles `.scrolled` on #nav based on scroll position.
  var nav = document.getElementById('nav');
  if (nav) {
    var ticking = false;
    function update() {
      var y = window.scrollY || 0;
      if (y > 8) { nav.classList.add('scrolled'); } else { nav.classList.remove('scrolled'); }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // 2. Reveal-on-scroll
  //    IntersectionObserver adds `.in` to `.r-up` / `.mask-reveal` elements.
  //    穩健化：design mode（編輯器）或減動偏好或不支援 IO → 直接全顯示；
  //    其餘情況，初始就在視窗內者（如 hero, above-the-fold）立即顯示、不等 IO，
  //    只有捲動才會進來的才交給 IO，避免字卡在 opacity:0 看不到。
  var designMode = window.Shopify && window.Shopify.designMode;
  function revealEls(els) {
    Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
  }
  var ups = document.querySelectorAll('.r-up, .mask-reveal');
  if (ups.length) {
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      revealEls(ups);
    } else {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var reveal = function (io) {
        return function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
          });
        };
      };
      // 一般元素：露出 16% 才顯現。
      var io = new IntersectionObserver(function (e) { reveal(io)(e); },
        { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      // 比視窗高很多的元素（如整篇文章內文）：可見比例最高只有 vh/高度，
      // 若小於 0.16 就永遠觸發不了、內容會卡在 opacity:0，
      // 因此改用 threshold 0 —— 上緣進入視窗下方 25% 處即顯現。
      var ioTall = new IntersectionObserver(function (e) { reveal(ioTall)(e); },
        { threshold: 0, rootMargin: '0px 0px -25% 0px' });
      Array.prototype.forEach.call(ups, function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) { el.classList.add('in'); return; }
        // 分流門檻必須把 io 的 rootMargin(-8%) 算進去：可見比例是相對「縮過的判定區」，
        // 只用 vh/h 會留下 0.16~0.174 的死角，元素卡在 opacity:0 永遠不顯現。
        // 再乘一段安全餘裕（0.22），寧可提早顯現也不要消失。
        var h = el.offsetHeight || r.height || 0;
        if (h > 0 && (vh * 0.92) / h < 0.22) { ioTall.observe(el); } else { io.observe(el); }
      });
    }
  }

  // 2b. 編輯器重新載入 section 時，補顯示新內容
  document.addEventListener('shopify:section:load', function (e) {
    revealEls((e.target || document).querySelectorAll('.r-up, .mask-reveal'));
    Array.prototype.forEach.call((e.target || document).querySelectorAll('[data-hero]'), function (h) { h.classList.add('loaded'); });
  });

  // 2c. Hero 進場 reveal 後備：hero 文字/疊層的顯示依賴 .hero.loaded，
  //     此處由可靠載入的 global.js 直接補上，避免 section JS bundle 未執行時文字卡在 opacity:0。
  Array.prototype.forEach.call(document.querySelectorAll('[data-hero]'), function (h) { h.classList.add('loaded'); });

  // 2d. 打字機：滑到視窗時逐字寫入（.typewriter / data-typewriter）
  Array.prototype.forEach.call(document.querySelectorAll('.typewriter'), function (el) {
    var text = el.dataset.typewriter || el.textContent || '';
    el.textContent = '';
    var i = 0, started = false, speed = 70;
    function play() {
      if (i < text.length) {
        el.textContent += text.charAt(i++);
        setTimeout(play, speed);
      } else {
        el.classList.add('done');
      }
    }
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      el.textContent = text;
      el.classList.add('done');
      return;
    }
    var tio = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting && !started) { started = true; play(); tio.unobserve(en.target); }
      });
    }, { threshold: 0.55 });
    tio.observe(el);
  });

  // 3. Back-to-top
  //    Shows #toTop after 600px scroll; clicks scroll to top.
  var toTop = document.getElementById('toTop');
  if (toTop) {
    var toggleTop = function () { toTop.classList.toggle('show', (window.scrollY || 0) > 600); };
    toggleTop();
    window.addEventListener('scroll', toggleTop, { passive: true });
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  // 4. Mobile menu
  //    #navToggle toggles #mobileMenu; closes on Esc or inner link click.
  var toggle = document.getElementById('navToggle');
  var menu = document.getElementById('mobileMenu');
  if (toggle && menu) {
    var open = false;
    function setMenu(state) {
      open = state;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? '關閉選單' : '開啟選單');
      menu.classList.toggle('open', open);
    }
    toggle.addEventListener('click', function () { setMenu(!open); });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) { setMenu(false); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) { setMenu(false); toggle.focus(); }
    });
  }

  // 5. 設計作品列表（cases-list section）：hero 輪播 + 類型/風格篩選
  //    放這裡（而非 section 的 {% javascript %}）以確保在 Theme Editor
  //    section 重載（shopify:section:load）後也會重新初始化；以 data flag 保證幂等。
  function initCasesList(root) {
    root = root || document;

    // hero 大圖輪播已由 initWhHeroes 共用處理（#worksHero）

    // ---- 類型 + 風格篩選 ----
    var grid = root.querySelector('#worksGrid');
    if (grid && !grid.dataset.filterInit) {
      grid.dataset.filterInit = '1';
      (function () {
        var scope = grid.closest('.works-body') || document;
        var works = Array.prototype.slice.call(grid.querySelectorAll('.work'));
        var catBtns = Array.prototype.slice.call(scope.querySelectorAll('.seg-btn'));
        var styleBtns = Array.prototype.slice.call(scope.querySelectorAll('.chip'));
        var countEl = scope.querySelector('#resultCount');
        var empty = scope.querySelector('#worksEmpty');
        var clearBtn = scope.querySelector('#clearFilters');
        var note = scope.querySelector('#filterNote');
        var activeEl = scope.querySelector('#resultsActive');
        var CAT_LABEL = { interior: '室內設計', universal: '全齡空間' };
        var cat = 'all', style = 'all';

        function matchCount(c, s) {
          var n = 0;
          works.forEach(function (w) { if ((c === 'all' || w.dataset.cat === c) && (s === 'all' || w.dataset.style === s)) n++; });
          return n;
        }
        function press(list, attr, val) { list.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset[attr] === val)); }); }
        function syncChips() {
          styleBtns.forEach(function (b) {
            var s = b.dataset.style;
            var avail = s === 'all' || matchCount(cat, s) > 0;
            b.disabled = !avail;
            b.setAttribute('aria-disabled', String(!avail));
          });
          if (style !== 'all' && matchCount(cat, style) === 0) { style = 'all'; press(styleBtns, 'style', 'all'); }
        }
        function summary() {
          var parts = [];
          if (cat !== 'all') parts.push(CAT_LABEL[cat] || cat);
          if (style !== 'all') { var sb = styleBtns.filter(function (b) { return b.dataset.style === style; })[0]; parts.push(sb ? sb.textContent.trim() : style); }
          return parts.join(' · ');
        }
        function writeURL() {
          var p = [];
          if (cat !== 'all') p.push('type=' + cat);
          if (style !== 'all') p.push('style=' + encodeURIComponent(style));
          try { history.replaceState(null, '', p.length ? '#' + p.join('&') : location.pathname + location.search); } catch (e) {}
        }
        function apply() {
          syncChips();
          var n = matchCount(cat, style);
          works.forEach(function (w) {
            var ok = (cat === 'all' || w.dataset.cat === cat) && (style === 'all' || w.dataset.style === style);
            w.classList.toggle('is-hidden', !ok);
          });
          if (countEl) countEl.textContent = n;
          if (empty) empty.classList.toggle('show', n === 0);
          grid.style.display = n === 0 ? 'none' : '';
          var active = cat !== 'all' || style !== 'all';
          if (clearBtn) clearBtn.hidden = !active;
          if (activeEl) { if (active) { activeEl.hidden = false; activeEl.innerHTML = '· 篩選 <b>' + summary() + '</b>'; } else { activeEl.hidden = true; activeEl.textContent = ''; } }
          if (note) note.hidden = cat !== 'universal';
          writeURL();
        }
        function readURL() {
          var h = (location.hash || '').replace(/^#/, '');
          if (!h) return;
          h.split('&').forEach(function (kv) {
            var p = kv.split('=');
            if (p[0] === 'type' && ['interior', 'universal'].indexOf(p[1]) >= 0) cat = p[1];
            if (p[0] === 'style' && p[1]) { try { style = decodeURIComponent(p[1]); } catch (e) {} }
          });
          press(catBtns, 'cat', cat);
          press(styleBtns, 'style', style);
        }
        function resetAll(scroll) {
          cat = 'all'; style = 'all';
          press(catBtns, 'cat', 'all'); press(styleBtns, 'style', 'all');
          apply();
          if (scroll) window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        }
        catBtns.forEach(function (b) { b.addEventListener('click', function () { cat = b.dataset.cat; press(catBtns, 'cat', cat); apply(); }); });
        styleBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; style = b.dataset.style; press(styleBtns, 'style', style); apply(); }); });
        var resetBtn = scope.querySelector('#resetFilters');
        if (resetBtn) resetBtn.addEventListener('click', function () { resetAll(true); });
        if (clearBtn) clearBtn.addEventListener('click', function () { resetAll(false); });
        readURL();
        apply();
      })();
    }
  }
  initCasesList(document);

  // 6. 作品詳情頁（case-detail section）：YouTube 點播 + 相簿燈箱
  //    同樣放 global.js 並支援 shopify:section:load 重載；以 data flag 保證幂等。
  function initCaseDetail(root) {
    root = root || document;

    // ---- YouTube 點播（facade 點擊換 iframe）----
    var vw = root.querySelector('.video-wrap');
    if (vw && !vw.dataset.ytInit) {
      vw.dataset.ytInit = '1';
      var fac = vw.querySelector('.video-facade');
      if (fac) {
        fac.addEventListener('click', function () {
          var id = vw.dataset.yt;
          if (!id) return;
          var f = document.createElement('iframe');
          f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
          f.title = vw.dataset.ytTitle || '作品影片';
          f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          f.allowFullscreen = true;
          f.setAttribute('loading', 'lazy');
          vw.innerHTML = '';
          vw.appendChild(f);
        });
      }
    }

    // ---- 相簿燈箱 ----
    var lb = document.getElementById('lightbox');
    var tilesWrap = root.querySelector('.gallery-sec') || root;
    var tiles = Array.prototype.slice.call(tilesWrap.querySelectorAll('.gtile'));
    if (lb && tiles.length && !lb.dataset.lbInit) {
      lb.dataset.lbInit = '1';
      var lbImg = document.getElementById('lbImg'), lbCap = document.getElementById('lbCap');
      var DATA = tiles.map(function (t) {
        return { src: t.getAttribute('data-full'), room: t.getAttribute('data-room') || '', alt: (t.querySelector('img') || {}).alt || '' };
      });
      var cur = 0, lastFocus = null;
      function show(n) {
        cur = (n + DATA.length) % DATA.length;
        var d = DATA[cur];
        lbImg.src = d.src; lbImg.alt = d.alt;
        lbCap.textContent = (d.room ? d.room + ' · ' : '') + (cur + 1) + ' / ' + DATA.length;
      }
      function openLb(n) { lastFocus = document.activeElement; show(n); lb.hidden = false; document.body.style.overflow = 'hidden'; lb.querySelector('.lb-close').focus(); }
      function closeLb() { lb.hidden = true; document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
      tiles.forEach(function (t, i) { t.addEventListener('click', function () { openLb(i); }); });
      lb.querySelector('.lb-close').addEventListener('click', closeLb);
      lb.querySelector('.lb-prev').addEventListener('click', function () { show(cur - 1); });
      lb.querySelector('.lb-next').addEventListener('click', function () { show(cur + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') { closeLb(); }
        else if (e.key === 'ArrowLeft') { show(cur - 1); }
        else if (e.key === 'ArrowRight') { show(cur + 1); }
        else if (e.key === 'Tab') {
          var f = Array.prototype.slice.call(lb.querySelectorAll('button'));
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
  }
  initCaseDetail(document);

  // 6b. 設計特色（作品頁）：捲到哪一條，右側大圖就翻到哪一張，像翻材質樣本冊。
  //     往下捲＝目前這張以左緣為軸被翻走，底下那張就位；
  //     往上捲＝要回去的那張從左緣翻回來，蓋掉目前這張。
  function initFeaturePeek(root) {
    root = root || document;
    var wraps = root.querySelectorAll ? root.querySelectorAll('[data-feat-wrap].has-stage') : [];
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.peekInit) return;
      wrap.dataset.peekInit = '1';

      var shots = wrap.querySelectorAll('.feat-shot');
      var feats = wrap.querySelectorAll('.feat.has-img');
      if (!shots.length || !feats.length) return;

      var TURN = 1050;                    // 與 CSS 翻頁動畫時長一致
      var current = null;                 // 目前對應的 li
      var currentShot = null;
      var timer = null;

      function shotFor(li) {
        var key = li.getAttribute('data-shot');
        var found = null;
        Array.prototype.forEach.call(shots, function (img) {
          if (img.getAttribute('data-shot') === key) found = img;
        });
        return found;
      }

      function activate(li) {
        if (li === current) return;
        var next = shotFor(li);
        if (!next) return;

        var from = currentShot;
        var back = current !== null &&
          Array.prototype.indexOf.call(feats, li) < Array.prototype.indexOf.call(feats, current);

        clearTimeout(timer);
        Array.prototype.forEach.call(shots, function (img) {
          img.classList.remove('is-active', 'was-active', 'is-returning', 'is-leaving', 'is-settling');
        });

        if (from && back) {
          // 往回翻：舊的留在下層，新的從左緣轉回來蓋上
          from.classList.add('is-leaving');
          void next.offsetWidth;
          next.classList.add('is-returning');
          timer = setTimeout(function () {
            from.classList.remove('is-leaving');
            next.classList.remove('is-returning');
            next.classList.add('is-active');
          }, TURN);
        } else {
          // 往下翻：舊的轉離視角，新的在底下就位
          if (from) { void from.offsetWidth; from.classList.add('was-active'); }
          next.classList.add('is-active');
          void next.offsetWidth;
          next.classList.add('is-settling');
          timer = setTimeout(function () {
            if (from) from.classList.remove('was-active');
            next.classList.remove('is-settling');
          }, TURN);
        }

        Array.prototype.forEach.call(feats, function (f) { f.classList.toggle('is-current', f === li); });
        current = li;
        currentShot = next;
      }

      // 以視窗中線當閱讀線：跨過中線的那一條就是目前這條，
      // 沒有任何一條跨到（section 剛進場／已捲過）時取最接近的。
      function pick() {
        var line = window.innerHeight * 0.5;
        var best = null, bestDist = Infinity;
        Array.prototype.forEach.call(feats, function (li) {
          var r = li.getBoundingClientRect();
          var d = (r.top <= line && r.bottom >= line) ? 0
                : (r.top > line ? r.top - line : line - r.bottom);
          if (d < bestDist) { bestDist = d; best = li; }
        });
        if (best) activate(best);
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; pick(); });
      }

      activate(feats[0]);
      pick();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    });
  }
  initFeaturePeek(document);

  // 7. 服務頁影片牆（service 頁的 .vid-thumb）：點縮圖換成 YouTube 嵌入
  function initServiceVideos(root) {
    root = root || document;
    var thumbs = root.querySelectorAll ? root.querySelectorAll('.vid-thumb') : [];
    Array.prototype.forEach.call(thumbs, function (btn) {
      if (btn.dataset.vidInit) return;
      btn.dataset.vidInit = '1';
      btn.addEventListener('click', function () {
        var id = btn.dataset.yt;
        if (!id) return;
        var wrap = document.createElement('div');
        wrap.className = 'vid-frame';
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        f.title = '影片';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        f.setAttribute('loading', 'lazy');
        wrap.appendChild(f);
        btn.replaceWith(wrap);
      });
    });
  }
  initServiceVideos(document);

  // 8. 大圖輪播（.wh-slide）共用：服務頁 .svc-hero 與作品列表頁 #worksHero 同一套
  function initWhHero(stage) {
    if (!stage || stage.dataset.whHeroInit) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.wh-slide'));
    if (slides.length < 2) return;
    stage.dataset.whHeroInit = '1';
    var dots = Array.prototype.slice.call(stage.querySelectorAll('.hc-dot'));
    var nowZh = stage.querySelector('#whNowZh'), nowMeta = stage.querySelector('#whNowMeta');
    var i = 0, timer = null, DUR = 5000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { var on = k === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      dots.forEach(function (d, k) { var on = k === i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var active = slides[i];
      if (nowZh && active) { nowZh.textContent = active.getAttribute('data-zh') || ''; if (nowMeta) { nowMeta.textContent = active.getAttribute('data-meta') || ''; } }
    }
    function start() { if (reduce || timer) return; timer = setInterval(function () { go(i + 1); }, DUR); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.i); stop(); start(); }); });
    stage.addEventListener('mouseenter', stop); stage.addEventListener('mouseleave', start);
    stage.addEventListener('focusin', stop); stage.addEventListener('focusout', start);
    if ('IntersectionObserver' in window) { var vio = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } }); }, { threshold: 0.2 }); vio.observe(stage); }
    else { start(); }
  }
  function initWhHeroes(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('.svc-hero, #worksHero'), initWhHero);
  }
  initWhHeroes(document);

  // 9. 文章章節目錄
  //    內文是後台富文字，Liquid 無法可靠解析標題，故在前端依 h2/h3 產生目錄。
  //    小標少於 2 個就不顯示（維持單欄）；捲動時標示目前章節。
  function initArticleToc(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    var wrap = root.querySelector('.art-body-wrap');
    if (!wrap || wrap.dataset.tocInit) return;
    var toc = wrap.querySelector('.art-toc');
    var list = wrap.querySelector('.art-toc-list');
    var body = wrap.querySelector('.article-body');
    if (!toc || !list || !body) return;
    wrap.dataset.tocInit = '1';

    var heads = Array.prototype.slice.call(body.querySelectorAll('h2, h3'))
      .filter(function (h) { return (h.textContent || '').trim(); });
    if (heads.length < 2) return;

    var links = heads.map(function (h, i) {
      if (!h.id) { h.id = 'art-sec-' + (i + 1); }
      var li = document.createElement('li');
      if (h.tagName === 'H3') { li.className = 'art-toc-sub'; }
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = (h.textContent || '').trim();
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + h.id); } catch (err) { /* 編輯器 iframe 會擋 */ }
      });
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    wrap.classList.add('has-toc');

    // 目前章節：取最後一個上緣已捲過導覽列的標題
    var ticking = false;
    function mark() {
      ticking = false;
      // 編輯器重載 section 後舊節點已脫離文件，解除監聽避免累積
      if (!heads[0].isConnected) { window.removeEventListener('scroll', onScroll); return; }
      var idx = -1;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top <= 120) { idx = i; } else { break; }
      }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === idx); });
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(mark); ticking = true; }
    }
    mark();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  initArticleToc(document);

  document.addEventListener('shopify:section:load', function (e) {
    initCasesList(e.target || document);
    initCaseDetail(e.target || document);
    initFeaturePeek(e.target || document);
    initServiceVideos(e.target || document);
    initWhHeroes(e.target || document);
    initArticleToc(e.target || document);
  });
})();
